export default __webpack_public_path__ + "static/holland&Barrett-fb477f666bdf4b29d132a444b4141a89.png";